import React from "react";
import { createEmptyNodeInput, MultipleChoiceInputUtils } from "api-sdk"
import { InfoBox, SelectComponent, SelectComponentType } from "reader-common";
import { ChatReaderComponentProps } from "../types";

export function MultipleChoiceInput(props: ChatReaderComponentProps<"MULTIPLE_CHOICE">) {

    const val = props.value

    return (
        <SelectComponent
            options={ props.inputField.options }
            noneOption={ props.inputField.noneOption }
            value={ val?.selectedOptionIds }
            onChange={ selectedOpts => {
                props.onChange(
                    selectedOpts != null
                        ? MultipleChoiceInputUtils.asNodeInput(selectedOpts as number[])
                        : createEmptyNodeInput()
                )
            } }
            showCheckboxes
            selectType={ SelectComponentType.MULTIPLE_CHOICE }
            isOptional={ !props.inputField.required }
            onClickAnnotation={ (e, txt) => {
                const finalProps = props
                finalProps.menu.showMenu({
                    anchor: e.currentTarget,
                    render: () => ( <InfoBox text={ txt } config={ finalProps.config } onClose={ finalProps.menu.dismissMenu } /> )
                })
            } }
            fileUrlProvider={ props.fileUrlProvider }
            optionClassName="chat-surface"
            autoFocus={ props.autoFocus }
        />
    )

}